import React from "react";
import { useApolloClient } from "@apollo/client";

export function useEvictLastestMessagesCache() {
	const client = useApolloClient();
	return React.useCallback(
		() => client.cache.evict({ id: "ROOT_QUERY", fieldName: "latestMessageByGroupConnection" }),
		[client],
	);
}
